import axios from "axios";
import Cookies from "js-cookie";
import { GeneratePublicToken } from "../utils/GeneratePublicToken";

const token = () => Cookies.get("accessToken");

export const setNewPassword = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/new-password`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getListProduct = async ({ limit, offset }) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/product?limit=${limit}&offset=${offset}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getListOutlet = async ({ limit, offset, search, companyId }) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${
        process.env.REACT_APP_API_PSEF
      }psef/outlet?limit=${limit}&offset=${offset}&search=${search}${
        companyId ? `&company_id=${companyId}` : ""
      }`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getDetailProduct = async (id) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/product-detail?id=${id}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getDetailProductBearer = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/product-detail-jwt?id=${id}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getDetailOutlet = async (id, limit, offset) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/outlet-detail?limit=${limit}&offset=${offset}&company_id=${id}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getPaymentMethod = async () => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${process.env.REACT_APP_API_MASTER}payment-method`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getShippingMethod = async () => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/shipping-methods`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const addToCart = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/add-cart-products${
        isLogin ? "-jwt" : ""
      }`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getListCart = async () => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const machineId = localStorage.getItem("MachineId");
  const companyId = localStorage.getItem("companyId");

  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/cart-products${
        isLogin ? "-jwt" : ""
      }?uuid=${machineId ? machineId : ""}&company_id=${
        companyId ? Number(companyId) : 0
      }`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getListCartInfo = async () => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const machineId = localStorage.getItem("MachineId");
  const companyId = localStorage.getItem("companyId");
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/cart-products-info${
        isLogin ? "-jwt" : ""
      }?uuid=${machineId ? machineId : ""}&company_id=${
        companyId ? Number(companyId) : 0
      }`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getListCartInfoJwt = async () => {
  const machineId = localStorage.getItem("MachineId");
  const companyId = localStorage.getItem("companyId");
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/cart-products-info-jwt?uuid=${
        machineId ? machineId : ""
      }&company_id=${companyId ? Number(companyId) : 0}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getTransactionCart = async () => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const machineId = localStorage.getItem("MachineId");
  const companyId = localStorage.getItem("companyId");
  const isLogin = token() && token() !== undefined && token() !== null;

  try {
    const header = isLogin
      ? { Authorization: `Bearer ${token()}` }
      : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/transaction-carts${
        isLogin ? "-jwt" : ""
      }?uuid=${machineId ? machineId : ""}&company_id=${
        companyId ? Number(companyId) : 0
      }`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const sendOtp = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/send-otp-purchase`,
      method: "POST",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getDoctorRecipe = async (product_id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/doctor-recipe?product_id=${product_id}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const addDoctorRecipe = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const machineId = localStorage.getItem("MachineId");
  const isLogin = token() && token() !== undefined && token() !== null;

  try {
    const header = isLogin
      ? { Authorization: `Bearer ${token()}` }
      : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/doctor-recipe${
        isLogin ? "-jwt" : ""
      }`,
      method: "POST",
      data: { ...body, uuid: machineId ? machineId : "" },
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const addDoctorCopyRecipe = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/doctor-recipe-copy`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const addDoctorCopyRecipeCart = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/doctor-recipe-copy`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getPrescriptionDoctor = async (recipe_id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/detail-prescription-doctor?id=${recipe_id}`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const uploadImage = async (image) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const body = new FormData();
    body.append("type", "public");
    body.append("datasource", "psef-prescription");

    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
        "Content-Type": "multipart/form-data",
      },
      url: `${process.env.REACT_APP_API_MASTER}upload/image`,
      method: "POST",
      data: {
        image,
        type: "public",
        datasource: "psef-prescription",
      },
    };

    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getCustomerAddress = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/user-address`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

// export const getDistanceOutlet = async (body) => {
//   const TokenAuth = GeneratePublicToken().Authorization;
//   const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
//   try {
//     const config = {
//       headers: {
//         Authorization: TokenAuth,
//         "Authorization-ID": TokenAuthID,
//       },
//       url: `${process.env.REACT_APP_API_PSEF}psef/outlet-distance`,
//       method: "POST",
//       data: body,
//     };
//     const res = await axios(config);
//     return res.data.detail;
//   } catch (err) {
//     throw err;
//   }
// };

export const setCustomerAddress = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/update-address`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const calculateBorzo = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const machineId = localStorage.getItem("MachineId");
  const isLogin = token() && token() !== undefined && token() !== null;

  try {
    const header = isLogin
      ? { Authorization: `Bearer ${token()}` }
      : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/borzo-calculate${
        isLogin ? "-jwt" : ""
      }`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getListCategory = async () => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: { Authorization: TokenAuth, "Authorization-ID": TokenAuthID },
      url: `${process.env.REACT_APP_API_PSEF}psef/categories`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getCartForTransaction = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  try {
    const header = isLogin
      ? { Authorization: `Bearer ${token()}` }
      : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/transaction-carts-jwt`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const mergeGuessCart = async (body) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/cart/merge`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getListPaymentMethod = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/payment-method`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getListPaymentConsultation = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/consultations-fee`,
      method: "GET",
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const checkAllCarts = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  try {
    const header = isLogin
      ? { Authorization: `Bearer ${token()}` }
      : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/check-all-carts`,
      method: "PUT",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const deleteAllCarts = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/delete-all-carts`,
      method: "DELETE",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};

export const getDetailLocation = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];

  try {
    const config = {
      headers: {
        Authorization: TokenAuth,
        "Authorization-ID": TokenAuthID,
      },
      url: `${process.env.REACT_APP_API_PSEF}psef/geography`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err;
  }
};
